module.exports = __webpack_public_path__ + "2c89d027cd2b1ff40f93b5302336bc0c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-jester-s.png
// module id = 1904
// module chunks = 0